var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "footer-subfooter-container bg-light-grey" },
    [
      _c("div", { staticClass: "footer-subfooter" }, [
        _vm.schema.settings.subfooterMenu.links.length > 0
          ? _c(
              "div",
              { staticClass: "footer-subfooter__menu" },
              _vm._l(_vm.schema.settings.subfooterMenu.links, function(link) {
                return _c(
                  "div",
                  {
                    key: link.id,
                    staticClass: "footer-subfooter__link-container"
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "footer-subfooter__link",
                        attrs: { href: link.url }
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass:
                              "link__content body-sm link link--primary"
                          },
                          [_vm._v(_vm._s(link.title))]
                        )
                      ]
                    )
                  ]
                )
              }),
              0
            )
          : _vm._e(),
        _c("div", { staticClass: "footer-subfooter__copyright body-sm" }, [
          _vm._v(_vm._s(_vm.schema.settings.copyrightText))
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }